import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators , AbstractControl} from '@angular/forms';
import { ClientsService } from '../clients.service';
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { Store } from '@ngrx/store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from 'src/app/services/company.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-creating-users',
  templateUrl: './creating-users.component.html',
  styleUrls: ['./creating-users.component.scss']
})
export class CreatingUsersComponent implements OnInit {

  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Input() companyId;
  listCountry: [];
  newPwdValidity:boolean;
  observableSubscription$ = new Subject();
  dirtyFlag: boolean = false;
  disableFields : boolean = false;
  public creatingUserForm: FormGroup;
  public userDetails:any= [];
  rollTypeList: object[] = [];
  formChangesSubscription: any;
  confirmPwdValidity:boolean = false;
  totalRecordCount:number;
  pageSize:number;
  pageIndex:number;
  searchText = "";
  confirm_password_hide: boolean = false;
  new_password_hide: boolean = false;

  constructor(private formBuilder: FormBuilder,
    protected store: Store<any>,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private companyService: CompanyService,
    private confirmationService: ConfirmationService,
    private cacheCountryService: CacheCountryService,
    private clientsService:ClientsService) {
      this.activatedRoute.params
      .subscribe(parameter => {
        let parameterId = null;
        if (parameter.hasOwnProperty('id')) {
          this.companyId = parameterId;
          this.companyService.getCompaniesById(parameter.id).subscribe(data => {
            // if(data.status.code == 'ACTV')
            //   this.disableFields = true;
          });
        } else {

        }
      });
     }

  ngOnInit(): void {
    // this.companyId = 425;
    this.totalRecordCount = 0;
    this.pageSize = 25;
    this.pageIndex = 1;
    this.creatingUserFormInitialize();
    this.cacheCountryService.getCachedCountryList().subscribe(data => {
      if (data.listCountries.length > 0) {
        this.listCountry = data.listCountries.map(x => {
          return {
            ...x,
            countryPhoneCode: `${x.countryCode} - ${x.phoneCode}`
          };
        });
      }
    });

    this.getUserRoles();
    this.getUserDetails();
  }

  ngAfterViewInit() {

    this.formChangesSubscription = this.creatingUserForm.statusChanges.subscribe(() => {
      if (this.creatingUserForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
        this.dirtyFlag = true;
      }
      else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.dirtyFlag = false;
      }
    });
  }

  getUserRoles(){
    this.rollTypeList = [];
    this.clientsService.getUserRolesByCompany(this.companyId).subscribe(data => {
      if(data){
         this.rollTypeList = data;
        // let selArray = [];
        // data.forEach((role) => {
        //       if (role['description'] === 'Petitioner Admin') {
        //         role['inactive']=true;
        //         selArray.push(role['id']);
        //       }
        //       else{
        //         role['inactive']=false;
        //       }
        //       this.rollTypeList.push(role);
        //     });
        // this.creatingUserForm.patchValue({
        //   rollType: selArray
        // });
      }
    });
  }

  editNewUser(data: any) {
    // console.log(data)
    this.creatingUserFormInitialize();
    let selArray = [];
    this.rollTypeList.forEach((role) => {
      data.roleIds.forEach((roleid) => {
          if (role['id'] === roleid) {
            selArray.push(role['id']);
          }
      });
    });
    this.creatingUserForm.patchValue({
      id: data.id,
      rollType: selArray,
      firstName: data.firstName,
      lastName: data.lastName,
      middleName: data.middleName,
      email: data.emailContacts[0].email,
      countryCode:data.phoneContacts[0].countryCode.countryCode,
      phoneNumber: data.phoneContacts[0].phoneNo,
      password: data.password,
      confirmPassword: data.password
    });
    this.confirmPwdValidity = true;
  }

  getUserDetails(){
    let payload = {
      searchText: this.searchText,
      pageNumber: this.pageIndex,
      recordsPerPage: this.pageSize
    }
    this.clientsService.getUserDetails(this.companyId, payload).subscribe((response: []) => {
      this.userDetails = response['employees'];
    });
  }

  paginationEvent(event:PageEvent){
    this.pageIndex =  event.pageIndex+1;
    this.pageSize = event.pageSize;
    this.getUserDetails();
  }

  validateInput(type, newpwd):boolean{
    let regex:RegExp;
    if(type == 'totalCount'){
      regex = /.{8,}$/;
    }
    else if(type == 'aA3'){
      regex = /^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\S]{3,}$/g
    }
    else if(type == 'number'){
      regex = /^(?=.*\d)/g;
    }
    else if(type == 'specChar'){
      regex = /^(?=.*\W)(?!.*\s)/g;
    }

    //this.setScore(newpwd.value);

    let str = newpwd.value;
    let res = str.match(regex);
    if(res){
      return true;
    }
    else {
      return false;
    }
  }

  creatingUserFormInitialize(){
    this.creatingUserForm = this.formBuilder.group({
      id:[0],
      rollType: [[],Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      middleName: [''],
      email: ['', Validators.required],
      countryCode:['', Validators.required],
      phoneNumber: ['', Validators.required],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });
    // this.creatingUserForm.setValidators(this.passwordMatch);
  }

  confirmPasswordMatch() {
    if (this.creatingUserForm.value.password === this.creatingUserForm.value.confirmPassword) {
       this.confirmPwdValidity = true;
    }
    else {
       this.confirmPwdValidity = false;
    }
  }

  // passwordMatch(group: FormGroup): any {
  //   if (group) {
  //     if (group.get("password").value !== group.get("confirmPassword").value) {
  //       return { notMatching: true };
  //     }else {
  //       return { notMatching: false }
  //     }
  //   }

  //   return null;
  // }

  creatingUserFormSub(){
    const payload = {
      id:this.creatingUserForm.controls['id'].value!==0?this.creatingUserForm.controls['id'].value : 0,
      countryCode: this.creatingUserForm.controls['countryCode'].value,
      email: this.creatingUserForm.controls['email'].value,
      firstName: this.creatingUserForm.controls['firstName'].value,
      lastName: this.creatingUserForm.controls['lastName'].value,
      middleName: this.creatingUserForm.controls['middleName'].value,
      phone: this.creatingUserForm.controls['phoneNumber'].value,
      roleIds: this.creatingUserForm.controls['rollType'].value,
      password: this.creatingUserForm.controls['password'].value
    };
    this.clientsService.createUser(this.companyId, payload)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.toastr.success(response.message, 'Success');
          this.creatingUserForm.reset();
          this.getUserDetails()
        }
      });
  }

  // passwordMatchtest(){
  //   const control = this.creatingUserForm.controls["password"];
  //   const matchingControl = this.creatingUserForm.controls["confirmpassword"];
  //   if (this.creatingUserForm.errors) {
  //     return false;
  //   } else {
  //     if (control.value !== matchingControl.value) {
  //       matchingControl.setErrors({ mustMatch: true });
  //       return false;
  //     }
  //   }
  // }

  setPwdValidity(flag) {
    this.newPwdValidity = flag;
    const control = this.creatingUserForm.controls["password"];
    if (!this.newPwdValidity) {
      control.setErrors({ mustMatch: true });
      return false;
    }
  }

  confirmDelete(uploadedFile){
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      accept: () => {
        this.deleteFiles(uploadedFile);
      },
      reject: () => {
      }
  });
  }

    deleteFiles(doc) {
        this.clientsService.deleteUser(this.companyId,doc.id).subscribe((response:any) => {
          if(response && response.status === 200){
            this.toastr.success(response.message, 'Success');
            this.getUserDetails();
          }
        });
    }


      onPrevious(){
        this.confirmationService.close();
        if (this.dirtyFlag) {
          this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
              update: {
                title: 'Unsaved Changes!',
                message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
              },
              // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
              buttons: ['No', 'Yes'],
              disableClose: true
            }
          }).afterClosed().subscribe(confirmed => {
            if (confirmed) {
              this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
              this.dirtyFlag = false;
              this.notify.emit(2);
            }
          });

        } else {
          this.notify.emit(2);
        }
      }

      onNext() {

        if (this.dirtyFlag) {

          this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
              update: {
                title: 'Unsaved Changes!',
                message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
              },
              // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
              buttons: ['No', 'Yes'],
              disableClose: true
            }
          }).afterClosed().subscribe(confirmed => {
            if (confirmed) {
              this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
              this.dirtyFlag = false;
              this.notify.emit(4);
            }
          });

        } else {
          this.notify.emit(4);
        }
      }

      onCancel(){
        if (this.dirtyFlag) {

          this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
              update: {
                title: 'Unsaved Changes!',
                message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
              },
              // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
              buttons: ['No', 'Yes'],
              disableClose: true
            }
          }).afterClosed().subscribe(confirmed => {
            if (confirmed) {
              this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
              this.dirtyFlag = false;
              this.router.navigate([`/attorney-landing/clients`]);
            }
          });

        } else {
          this.router.navigate([`/attorney-landing/clients`]);
        }

      }

}
